import React from 'react'
import { Layout, Menu, Button, Avatar, Dropdown } from 'antd'
import {
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PoweroffOutlined,
  LockOutlined
} from '@ant-design/icons'

import cx from "classnames"
import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext'
import { Link } from "react-router-dom"

const { Header } = Layout

const HeaderOne = () => {
  const { logout } = useAuth()
  const { headerFixed, collapsed, toggleFullCollapse } = useTheme()

  const menu = (
    <Menu>
      <Menu.Item key="1">
      <Link to="/auth/change-pass"><Button type="text" icon={<LockOutlined />}>Change Password</Button></Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <Button onClick={logout} type="text" icon={<PoweroffOutlined />}>Logout</Button>
      </Menu.Item>
    </Menu>
  )

  return (
    <Header className={cx("bg-white", { "ant-header-fixed": headerFixed })}>
      {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: 'trigger',
        onClick: toggleFullCollapse,
      })}
      {/* <Header className="bg-white" style={{ padding: 0 }} /> */}
      <Dropdown overlay={menu} placement="topRight" arrow className="">
        <div className="user-box">
          <Avatar
            className="bg-primary"
            style={{
              verticalAlign: 'middle',
            }}
            size="large"
            // gap={gap}
            icon={<UserOutlined />}
          >
            {/* {user.displayName} */}
          </Avatar>
          {/* <DownOutlined /> */}
          {/* <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
            Click me
          </a> */}
        </div>
      </Dropdown>
    </Header>
  )
}

export default HeaderOne